var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "webContent flex" }, [
    _c("div", { staticClass: "detail" }, [
      _c("div", { staticClass: "title" }, [_vm._v(_vm._s(_vm.title))]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "txt", domProps: { innerHTML: _vm._s(_vm.txt) } },
        [_vm._v(_vm._s(_vm.txt))]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "end df hao" }, [
        _c("div", { staticClass: "answerBtn", on: { click: _vm.toAnswer } }, [
          _vm._v("写回答")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "flex" }),
        _vm._v(" "),
        _c("div", { staticClass: "like" }, [
          _vm._v(_vm._s(_vm.likeCount) + " 点赞")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "answer" }, [
          _vm._v(_vm._s(_vm.answerCount) + " 回答")
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "handle df hao" }, [
        _c("div", { staticClass: "date" }, [_vm._v(_vm._s(_vm.date))]),
        _vm._v(" "),
        _c("div", { staticClass: "user" }, [_vm._v(_vm._s(_vm.user))]),
        _vm._v(" "),
        _c("div", { staticClass: "flex df war hao" }, [
          _c(
            "div",
            {
              staticClass: "topBtn",
              class: { none: _vm.type == "top" || _vm.type == "prize" },
              on: {
                click: function($event) {
                  return _vm.handle("top")
                }
              }
            },
            [_vm._v("置顶")]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "prizeBtn",
              class: { none: _vm.type == "top" || _vm.type == "prize" },
              on: {
                click: function($event) {
                  return _vm.handle("prize")
                }
              }
            },
            [_vm._v("加精")]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "removeBtn" }, [_vm._v("删除")])
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "list" },
        _vm._l(_vm.list, function(v, i) {
          return _c(
            "div",
            {
              key: i,
              staticClass: "li",
              class: { "li-blue": v.userpower == "teacher" }
            },
            [
              _c("div", { staticClass: "li-tool df hao" }, [
                _c("div", { staticClass: "li-user" }, [_vm._v(_vm._s(v.user))]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "li-follow",
                    class: { has: v.isFollow },
                    on: {
                      click: function($event) {
                        return _vm.followItem(i)
                      }
                    }
                  },
                  [_vm._v(_vm._s(v.isFollow ? "已关注" : "关注"))]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "flex" }),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "li-collect",
                    class: { has: v.isCollect },
                    on: {
                      click: function($event) {
                        return _vm.collectItem(i)
                      }
                    }
                  },
                  [_vm._v(_vm._s(v.isCollect ? "已收藏" : "收藏"))]
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "li-txt",
                  domProps: { innerHTML: _vm._s(v.txt) }
                },
                [_vm._v(_vm._s(v.txt))]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "li-end df hao jcb" }, [
                _c("div", { staticClass: "li-date" }, [_vm._v(_vm._s(v.date))]),
                _vm._v(" "),
                _c("div", { staticClass: "li-like" }, [
                  _vm._v(_vm._s(v.likeCount))
                ])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "li-btn df war hao" }, [
                _c(
                  "div",
                  {
                    staticClass: "li-archiveBtn",
                    on: {
                      click: function($event) {
                        return _vm.openConfirm("archive", "")
                      }
                    }
                  },
                  [_vm._v("归档")]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "li-removeBtn" }, [_vm._v("删除")])
              ])
            ]
          )
        }),
        0
      )
    ]),
    _vm._v(" "),
    _vm.collectBase.has
      ? _c("div", { staticClass: "collectBase" }, [
          _c("div", { staticClass: "collectBase-box" }, [
            _c("div", { staticClass: "collectBase-top" }, [
              _c("div", {
                staticClass: "collectBase-close",
                on: { click: _vm.closeCollectBase }
              }),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  "已选择" + _vm._s(_vm.collectBase.choose.length) + "个收藏夹"
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "collectBase-add",
                  on: { click: _vm.showCollectAddBase }
                },
                [_vm._v("新建收藏夹")]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "collectBase-list" },
              _vm._l(_vm.collectBase.list, function(v, i) {
                return _c(
                  "div",
                  {
                    key: i,
                    staticClass: "collectBase-li",
                    class: { cur: _vm.collectBase.choose.indexOf(i) >= 0 },
                    on: {
                      click: function($event) {
                        return _vm.chooseCollectBase(i)
                      }
                    }
                  },
                  [
                    _c("div", { staticClass: "collectBase-title" }, [
                      _vm._v(_vm._s(v.title))
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "collectBase-answer" }, [
                      _vm._v(_vm._s(v.answerCount) + "个回答")
                    ])
                  ]
                )
              }),
              0
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "collectBase-btn",
                on: { click: _vm.resCollectBase }
              },
              [_vm._v("确认")]
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.collectAddBase.has
      ? _c("div", { staticClass: "collectAddBase df wao hao" }, [
          _c("div", { staticClass: "collectAddBase-box" }, [
            _c("div", { staticClass: "collectAddBase-input df hao" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.collectAddBase.val,
                    expression: "collectAddBase.val"
                  }
                ],
                staticClass: "flex",
                attrs: { type: "text", puc: "", placeholder: "输入收藏夹标题" },
                domProps: { value: _vm.collectAddBase.val },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.collectAddBase, "val", $event.target.value)
                    },
                    _vm.checkInput
                  ]
                }
              }),
              _vm._v(" "),
              _c("i", [_vm._v(_vm._s(13 - _vm.collectAddBase.val.length))])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "collectAddBase-end df war hao" }, [
              _c(
                "div",
                {
                  staticClass: "collectAddBase-btn",
                  on: { click: _vm.resCollectAddBase }
                },
                [_vm._v("确认")]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "collectAddBase-btn",
                  on: { click: _vm.closeCollectAddBase }
                },
                [_vm._v("取消")]
              )
            ])
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.confirm.has
      ? _c("div", { staticClass: "confirm df wao hao" }, [
          _c("div", { staticClass: "confirm-box" }, [
            _vm.confirm.type == "archive"
              ? _c("div", { staticClass: "confirm-txt" }, [
                  _vm._v("确认将该回答进行"),
                  _c("em", [_vm._v("归档")]),
                  _vm._v("操作吗？")
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "confirm-end df war hao" }, [
              _vm.confirm.type == "archive"
                ? _c(
                    "div",
                    {
                      staticClass: "confirm-btn",
                      on: { click: _vm.resConfirm }
                    },
                    [_vm._v("确认归档")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "confirm-btn", on: { click: _vm.closeConfirm } },
                [_vm._v("取消")]
              )
            ])
          ])
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6d58bfcd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d58bfcd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/admin/detail/detail.vue
// module id = null
// module chunks = 